import axios from "axios";

export const generateBookingSession = async () => {
  try {
    const testResponse = await axios.post(
      "/server/bookingidgenerator"
    );

    const parsedOutput = JSON.parse(testResponse.data.output);

    return parsedOutput.bookingId;

  } catch (err) {
    console.error("Booking session error:", err);
    throw err;
  }
};
